<template lang="html">
    <div>
        <!--     <data-table url="user" model="User" :fields="fields" :create="canCreate" action-buttons :actions="actions" primary-key="uuid"></data-table> -->
        <section>
            <b-field grouped group-multiline>
                <b-select v-model="perPage" @input="getData">
                    <option value="5">5 por página</option>
                    <option value="10">10 por página</option>
                    <option value="15">15 por página</option>
                    <option value="20">20 por página</option>
                </b-select>
                <div class="control" v-if="$auth.check(['super','admin','root'])">
                    <router-link class="button is-success" :to="{name: 'CreateUser'}">
                        Nuevo Registro
                    </router-link>
                </div>
                <div>
                    <b-select v-model="provider" placeholder="Provider">
                        <option value="">Seleccionar</option>
                        <option :value="provider.id" :key="provider.id" v-for="provider in providers">{{provider.name}}</option>
                    </b-select>
                </div>
                <div>
                    <b-input placeholder="Filtrar..." v-model="filter"/>
                </div>
                <div>
                    <b-button @click="getData">Buscar</b-button>
                </div>
            </b-field>
            <b-table
                    :data="data"
                    paginated
                    :loading="loading"
                    :per-page="perPage"
                    backend-pagination
                    default-sort="id"
                    backend-sorting
                    :current-page="currentPage"
                    :total="total"
                    @sort="sorted"
                    @page-change="pageChange">

                <template slot-scope="props">
                    <b-table-column label="Acciones" width="40">
                        <action-buttons :row="props.row" primary-key="uuid" show edit dele @deleteData="getData"
                                        url="user" model="User">
                            <template slot-scope="item">
                                <show-user :item="item.item"></show-user>
                            </template>
                        </action-buttons>
                    </b-table-column>
                    <b-table-column field="name" label="Nombre" sortable>
                        {{ props.row.profile.name }}
                    </b-table-column>

                    <b-table-column field="last_name" label="Apellido paterno" sortable>
                        {{ props.row.profile.last_name }}
                    </b-table-column>
                    <b-table-column field="other_name" label="Apellido materno" sortable>
                        {{ props.row.profile.other_name}}
                    </b-table-column>
                    <b-table-column field="email" label="Email" sortable>
                        {{ props.row.email}}
                    </b-table-column>
                    <b-table-column field="provider" label="Departamento">
                        {{ props.row.provider ? props.row.provider.name: ''}}
                    </b-table-column>
                    <b-table-column field="rol" label="Rol">
                        {{ props.row.role[0]|rol}}
                    </b-table-column>

                </template>
            </b-table>
        </section>
    </div>
</template>

<script>


    export default {
        data() {
            return {
                data: [],
                currentPage: 1,
                perPage: 10,
                total: 0,
                order: 'desc',
                field: 'id',
                loading: false,
                filter: '',
                providers: [],
                provider: ''
            }
        },
        created() {
            this.prepareComponent()
        },
        methods: {
            prepareComponent() {
                this.getData()
                this.getProviders();
            },
            sorted(field, order) {
                this.field = field;
                this.order = order;
                this.getData()
            },
            pageChange(page) {
                this.currentPage = page;
                this.getData()
            },
            getProviders(){
                this.$http.get('/ivr/provider').then(({data}) => {
                    this.providers = data.data
                })
            },
            getData() {
                this.loading = true
                this.$http.get('/user', {
                    params: {
                        pagesize: this.perPage,
                        page: this.currentPage,
                        field: this.field,
                        sorting: this.order,
                        filter: this.filter,
                        provider: this.provider
                    }
                }).then(response => {
                    this.loading = false;
                    let res = response.data;
                    this.data = res.data;
                    this.total = res.total
                }, error => {
                    this.loading = false;
                    Toast.danger(error.response.data.message)
                })
            }
        }
    }
</script>

<style lang="css">
</style>
